import Promotions from 'components/Offers/components/Promotions';
import PromotionsMobile from 'components/Offers/components/Promotions/mobile';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterFitHeight from 'components/common/CollapsibleSideMenu/OuterFitHeight';
import OuterPathContent from 'components/common/CollapsibleSideMenu/OuterPathContent';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import { useDetectDevice } from 'hooks/useDetectDevice';
import React from 'react';

const PromotionsPage = () => {
  const { isMobile, isTablet } = useDetectDevice();

  if (isMobile || isTablet) {
    return (
      <OuterBodyContent>
        <PromotionsMobile />
        <NavbarFooter />
      </OuterBodyContent>
    );
  }
  return (
    <CollapsibleSideMenu>
      <OuterBodyContent>
        <OuterPathContent>
          <OuterFitHeight>
            <Promotions />
          </OuterFitHeight>
        </OuterPathContent>
      </OuterBodyContent>
    </CollapsibleSideMenu>
  );
};

export default PromotionsPage;
